import request from '@/utils/request'
import store from '@/store'

// 获取当前登录用户的 adminId
function getAdminId() {
  return store.state.userInfo?.id || store.state.userInfo?.adminId || JSON.parse(localStorage.getItem('userInfo') || '{}').id
}

// 登录
export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/admin/info',
    method: 'get'
  })
}

// 修改密码
export function updatePassword(data) {
  return request({
    url: '/admin/password',
    method: 'put',
    data
  })
}

// 获取用户列表
export function getUserList(params) {
  return request({
    url: '/user/list',
    method: 'get',
    params: {
      ...params,
      adminId: getAdminId()
    }
  })
}

// 删除用户
export function deleteUser(id) {
  return request({
    url: `/user/delete/${id}`,
    method: 'delete',
    params: {
      adminId: getAdminId()
    }
  })
}

// 导出用户参与记录
export function exportUser(data) {
  return request({
    url: '/user/exportUser',
    method: 'get',
    params: {
      ...data,
      adminId: getAdminId()
    },
    responseType: 'blob' // 重要：设置响应类型为 blob
  })
}

// 导入Excel报名用户（Excel列：姓名、电话、自定义字段1~4）
export function importUsers(code, file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/user/import',
    method: 'post',
    params: { code },
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 清空所有导入的用户
export function clearImportedUsers(adminId) {
  return request({
    url: '/user/clear',
    method: 'post',
    data: { adminId }
  })
}

// 下载导入模板（code 为活动编码）
export function downloadImportTemplate(code) {
  return request({
    url: '/user/import/template',
    method: 'get',
    params: { code },
    responseType: 'blob'
  })
}

// ========== 临时需求：修改用户自定义字段值（抽奖次数） - 后续移除 ==========
export function updateUserCustomValue(userId, fieldIndex, value) {
  return request({
    url: '/user/updateCustomValue',
    method: 'put',
    data: { userId, fieldIndex, value }
  })
}

// 紧急修复：批量回填该活动下 user 表中字段为空的记录
export function repairEmptyRecords() {
  return request({
    url: '/user/repairEmptyRecords',
    method: 'post',
    params: {
      adminId: getAdminId()
    }
  })
}
